import { BlogList } from "../../components";
import {
  getAllBlog,
  getAllBlogCategories,
  getBlogRelations,
} from "../../lib/api";
import { BlogPost, BlogCategory } from "../../lib/models";
import { getGlobalStaticProps } from "../../lib/helpers";

interface BlogIndexData {
  posts: BlogPost[];
  categories: BlogCategory[];
}

export default function BlogIndex({ data }: { data: BlogIndexData }) {
  return (
    <BlogList title="Blog" categories={data.categories} posts={data.posts} />
  );
}

export async function getStaticProps() {
  const posts = await Promise.all((await getAllBlog()).map(getBlogRelations));
  const data: BlogIndexData = {
    posts,
    categories: await getAllBlogCategories(),
  };
  const props = await getGlobalStaticProps({ data }, { pageTitle: "Blog" });
  return { props };
}
